import { ListItemText, MenuItem, TextField } from '@mui/material';
import { isNullOrUndefined, validateNotNullOrUndefined } from '@vy/utils';
import { useState } from 'react';
import { VyDialog } from '../../../../../components/new-design/feedback/VyDialog';
import { useUpdateMeasurement } from '../../../../../hooks/requests/use-update-measurement';
import { useDialog } from '../../../../../hooks/use-dialog';
import { runMutation } from '../../../../../utils/vy-mutation';

type EditMeasurementDialogProps = {
  currentValue: number;
  measurementId: string;
};

export const EditMeasurementDialog: React.FC<EditMeasurementDialogProps> = ({
  currentValue,
  measurementId,
}) => {
  const { isDialogOpen, handleOpen, handleClose } = useDialog();
  const [units, setUnits] = useState<number | undefined>();
  const EditMeasurementMutation = useUpdateMeasurement();

  const handleDialogSubmit = async () => {
    handleClose();
    validateNotNullOrUndefined(units, 'Units is required');

    await runMutation(
      EditMeasurementMutation,
      {
        id: measurementId,
        units,
      },
      {
        pending: 'Updating...',
        success: 'Updated',
        error: 'Failed to update measurement',
      },
    );
  };

  return (
    <>
      <MenuItem
        onClick={handleOpen}
        sx={{
          paddingBottom: '9px',
        }}
      >
        <ListItemText>Edit</ListItemText>
      </MenuItem>

      <VyDialog
        open={isDialogOpen}
        onClose={handleClose}
        label="Edit measurement"
        labelDescription="You are about to update the events measured "
        warningText="This may have impact on open invoices "
        cancelButtonText="Cancel"
        ctaText="Edit"
        ctaDisabled={EditMeasurementMutation.isLoading || isNullOrUndefined(units)}
        onSubmit={handleDialogSubmit}
      >
        <div className="p-2">
          <TextField
            label="Units"
            placeholder={String(currentValue)}
            fullWidth
            size="medium"
            onChange={(event) => setUnits(Number(event.target.value))}
          />
        </div>
      </VyDialog>
    </>
  );
};
